
import CommonHelper from './CommonHelper';

class SCHError  {

  constructor() {
    this.title = 'error';
    this.message = 'unknown';
    this.httpStatus = -1;
  }

  setTitle(title){
    this.title = title;
  }

  setMessage(message){
    this.message = message;
  }

  setHttpStatus(status){
    this.httpStatus = status;
  }

  getFormattedMessage() {
    return CommonHelper.uppercaseFirstLetter(this.title) + ': ' + this.message;
  }

  getFormattedMessageWithOperationName(opName) {
    return opName + ' has failed due to ' + this.title + ' (' + this.message + ')';
  }

  //  var message,
}

export default SCHError;
